import {AfterViewInit, Component, OnInit} from '@angular/core';
import {DataService} from '../../../../Services/data.service';
import {Router} from '@angular/router';
import {AppConfigService} from '../../../../Services/app-config.service';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {ResponseModel} from '../../../../DataModels/response-model';
import {NgbPaginationConfig} from '@ng-bootstrap/ng-bootstrap';
import {PagerStateService} from '../../../../Services/pager-state.service';
import {NgbpaginationConfigService} from '../../../../Services/ngbpagination-config.service';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-budget-list',
  templateUrl: './budget-list.component.html',
  styleUrls: ['./budget-list.component.css'],
  standalone: false
})
export class BudgetListComponent implements OnInit, AfterViewInit {
  constructor(
    private table: DataService,
    private toastr: BsToastService,
    private router: Router,
    private appConfig: AppConfigService,
    private ngbConfig: NgbPaginationConfig,
    private pagerStatus: PagerStateService,
    private pagerConfig: NgbpaginationConfigService,
    private titleService: Title,
  ) {
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
  }

  vm: any = {list: [], searchHidden: false};


  // ngb paginate and page size
  page = 1;
  pageSize = this.appConfig.ListPageSize;
  startIndex = 1;
  endIndex = 0;
  totalRecords = 0;
  pageSizeOptions: number[] = [];

  ngOnInit(): void {
    this.vm.list = [];
    this.pageSizeOptions = this.appConfig.gridPageSizeSelection;
    // Restore pager from enhanced per-tab cache (sessionStorage + memory)
    try {
      const key = this.pagerStatus.buildKey(this.router.url);
      const restored = this.pagerStatus.restoreState(key);
      if (restored) {
        this.page = restored.lastPage || this.page;
        this.pageSize = restored.lastPageSize || this.pageSize;
        this.startIndex = restored.startIndex || this.startIndex;
        this.endIndex = restored.endIndex || this.endIndex;
      }
    } catch {
    }
    // this.getData('780cc033-ca1b-4ced-ac6e-5e49ca4fcb70');
    this.getData();
  }

  ngAfterViewInit(): void {
    this.titleService.setTitle($localize`:Budget List @@budgetList:Budget List`);
  }



  // Search UI toggle
  hideSearch(): void {
    this.vm.searchHidden = !this.vm.searchHidden;
  }

  // API fetch
  getData(search: string = '', fromDate: string = '', toDate: string = ''): void {
    const params = `?pageNumber=${this.page - 1}`
      + `&pageSize=${this.pageSize}`
      + `${search ? `&search=${encodeURIComponent(search)}` : ''}`
      + `${fromDate ? `&fromDate=${encodeURIComponent(fromDate)}` : ''}`
      + `${toDate ? `&toDate=${encodeURIComponent(toDate)}` : ''}`;
    this.table.getApiListData('budget', params).subscribe({
      next: (result: ResponseModel) => {
        this.vm.list = result?.Data || [];
        this.totalRecords = result?.totalRecords || this.vm.list.length;
        this.updatePagerIndices();
      },
      error: () => {
        this.toastr.showErrorToast('Failed to load budgets');
        this.vm.list = [];
        this.totalRecords = 0;
        this.updatePagerIndices();
      }
    });
  }

  // Pagination
  paginate(): void {
    // Always persist pager snapshot when user paginates
    this.savePagerState();
    this.getData();
  }

  updatePagerIndices(): void {
    if (!this.totalRecords) {
      this.startIndex = 0;
      this.endIndex = 0;
      return;
    }
    this.startIndex = (this.page - 1) * this.pageSize + 1;
    this.endIndex = Math.min(this.startIndex + this.pageSize - 1, this.totalRecords);
    // After indices are computed from the latest server response, persist state
    this.savePagerState();
  }

  // Persist pager state to per-tab cache (sessionStorage + in-memory)
  private savePagerState(): void {
    try {
      const key = this.pagerStatus.buildKey(this.router.url);
      this.pagerStatus.storeState(key, {
        lastPage: this.page,
        lastPageSize: this.pageSize,
        startIndex: this.startIndex,
        endIndex: this.endIndex,
        totalRecords: this.totalRecords,
        dateTime: Date.now(),
      } as any);
    } catch {
      // ignore persistence errors
    }
  }

  // Searching
  serverSearch(value: any): void {
    const term = (value && (value.searchTerm || value.search_string)) ? (value.searchTerm || value.search_string) : '';
    const fromDate = (value && value.fromDate) ? value.fromDate.toISOString() : '';
    const toDate = (value && value.toDate) ? value.toDate.toISOString() : '';
    // console.log('Server search -> term:', term, 'fromDate:', fromDate, 'toDate:', toDate);
    this.getData(term, fromDate, toDate);
  }

  clearServerSearch(_: any): void {
    this.getData('');
  }

  // Navigate to form
  onNavigate(id: any): void {
    const query = id ? `?id=${id}` : '';
    this.router.navigateByUrl(`/admin/budget-form${query}`);
  }
}
